import { Grid, Text } from '@mantine/core';
import type { UseFormReturn } from 'react-hook-form';
import { Show } from '../../../../../../../react-commons/components/control-flow/Show';
import { Form_RichText } from '../../../../../../../react-commons/components/form/inputs/Form_RichText';
import type { FormNames } from '../../../../../../../react-commons/utils/form/getFormNames';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    ProcessArtifactPropertyValidation,
    type ProcessArtifactResource,
} from '../../../../../resource/resources/artifacts/process_artifact/processArtifactResource';
import { PropertyInputs } from '../../../../reusable-components/base/property-bases/PropertyInputs';
import type { PropertyValidationInformation } from '../../../../util/PropertyValidationInformation';

export const ProcessArtifactContent = ({
    id,
    form,
    formNames,
    readOnly,
    displayedInOverview,
}: {
    id?: string;
    form: UseFormReturn<ProcessArtifactResource>;
    formNames: FormNames<ProcessArtifactResource>;
    readOnly: boolean;
    displayedInOverview?: boolean;
}) => {
    const getPropertyValidationInformation = (
        propertyIdentifier: ProcessArtifactPropertyValidation
    ): PropertyValidationInformation => ({
        resourceId: id,
        resourceType: ResourceType.PROCESS_ARTIFACT,
        propertyIdentifier,
    });

    return (
        <Grid>
            <Show when={!displayedInOverview}>
                <Grid.Col span={12}>
                    <PropertyInputs.Name
                        name={formNames.name}
                        control={form.control}
                        readOnly={readOnly}
                        propertyValidationInformation={getPropertyValidationInformation(
                            ProcessArtifactPropertyValidation.NAME
                        )}
                    />
                </Grid.Col>
            </Show>
            <Grid.Col span={12}>
                <Text>Description</Text>
                <Form_RichText name={formNames.description} form={form} readonly={readOnly} />
            </Grid.Col>
        </Grid>
    );
};
